{
  "es": {
    "title": {
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "home": "Inicio",
      "ships": {
        "index": "Naves",
        "viewer": "Ship Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} Images",
      "shipVideos": "%{name} Videos",
      "shipViewer": "%{name} Viewer",
      "images": "Imágenes",
      "stats": "Estadísticas",
      "login": "Iniciar sesión",
      "signUp": "Registrarse",
      "embed": "Widget Embebido",
      "apiV1": "API V1",
      "apiV1Schema": "Esquema",
      "apiV1Pagination": "Paginación",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Esquema",
      "hangar": {
        "index": "Mi hangar",
        "preview": "Vista previa de mi hangar",
        "stats": "Estadísticas de mi hangar",
        "import": "Importar",
        "public": "Hangar de %{user}",
        "publicStats": "%{user} Hangar Stats",
        "wishlist": "Lista de deseos",
        "publicWishlist": "Lista de deseos de %{user}",
        "vehicleLoadouts": "Loadouts de la nave",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "Carga de la nave"
      },
      "requestPassword": "Solicitar contraseña",
      "changePassword": "Cambiar contraseña",
      "fleets": {
        "add": "Create a new Fleet",
        "preview": "Vista previa de flota",
        "invites": "Invitaciones de flota",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "Mapa mundial de miembros de %{fleet}",
          "starmap": "Mapa estelar de miembros de %{fleet}"
        },
        "stats": "Estadísticas de %{fleet}",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories"
        },
        "missions": {
          "index": "Misiones de %{fleet}",
          "create": "Crear misión - %{fleet}",
          "edit": {
            "basic": "Editar misión - %{fleet}",
            "description": "Editar descripción - %{fleet}",
            "teams": "Editar equipos y plazas - %{fleet}"
          },
          "show": "Misión de %{fleet}"
        },
        "events": {
          "index": "Eventos de %{fleet}",
          "calendar": "Calendario de %{fleet}",
          "create": "Crear evento - %{fleet}",
          "edit": {
            "basic": "Editar evento - %{fleet}",
            "description": "Editar descripción - %{fleet}",
            "teams": "Editar equipos y plazas - %{fleet}"
          },
          "show": "Evento de %{fleet}"
        },
        "settings": {
          "index": "Configuración de %{fleet}",
          "fleet": "Configuración de %{fleet}",
          "membership": "Membresía de %{fleet}",
          "roles": "Roles de %{fleet}",
          "notifications": "Configuración de notificaciones de %{fleet}",
          "discord": "Configuración de Discord de %{fleet}",
          "calendar": "Configuración del calendario de %{fleet}",
          "features": "Funciones de %{fleet}"
        }
      },
      "roadmap": {
        "index": "Hoja de ruta",
        "ships": "Hoja de ruta de naves",
        "changes": "Cambios de la hoja de ruta"
      },
      "settings": {
        "index": "Configuración del perfil",
        "profile": "Configuración del perfil",
        "account": "Cuenta",
        "hangar": "Configuración del hangar",
        "privacy": "Configuración de privacidad",
        "features": "Indicadores de características",
        "connections": "Conexiones",
        "oauthApplications": "Aplicaciones OAuth",
        "notifications": "Configuración de notificaciones",
        "calendar": "Suscripción al calendario",
        "security": "Seguridad de la cuenta",
        "twoFactor": {
          "enable": "Enable Two-factor Authentiation",
          "disable": "Disable Two-factor Authentiation",
          "backupCodes": "Generate Two-Factor Backup Codes"
        }
      },
      "compare": {
        "ships": "Comparar naves"
      },
      "notFound": "404",
      "tools": {
        "index": "Herramientas",
        "travelTimes": "Tiempos de Viaje",
        "cargoGrids": "Grillas de carga"
      },
      "impressum": "Aviso legal",
      "privacyPolicy": "Política de privacidad",
      "cookiePolicy": "Política de cookies",
      "visualTests": {
        "index": "Pruebas Visuales",
        "panels": "Paneles - Pruebas Visuales",
        "buttons": "Botones - Pruebas Visuales",
        "events": "Eventos",
        "typography": "Tipografía - Pruebas visuales",
        "forms": "Formularios - Pruebas visuales",
        "tables": "Tablas - Pruebas Visuales",
        "lists": "Listas - Pruebas visuales",
        "metrics": "Métricas - Pruebas visuales",
        "states": "Estados - Pruebas visuales",
        "notifications": "Notificaciones - Pruebas Visuales",
        "syncModal": "Modal de sincronización - Pruebas Visuales",
        "overlays": "Superposiciones - Pruebas Visuales",
        "supportHint": "Aviso de apoyo - Pruebas Visuales",
        "media": "Multimedia - Pruebas Visuales",
        "charts": "Gráficos - Pruebas Visuales",
        "chips": "Chips - Pruebas Visuales",
        "notificationCenter": "Centro de notificaciones - Pruebas Visuales"
      },
      "admin": {
        "models": {
          "index": "Modelos",
          "new": "Nuevo Modelo",
          "edit": {
            "index": "Editar %{manufacturer} %{model}",
            "metrics": "Editar métricas de %{manufacturer} %{model}",
            "prices": "Editar precios de %{manufacturer} %{model}",
            "fleetchart": "Editar imágenes del gráfico de flota de %{manufacturer} %{model}",
            "positions": "Editar posiciones de %{manufacturer} %{model}",
            "hardpoints": "Editar puntos de montaje de %{manufacturer} %{model}",
            "cargoAndFuel": "Editar combustible de %{manufacturer} %{model}",
            "cargoHolds": "Editar bodegas de carga de %{manufacturer} %{model}",
            "docks": "Editar muelles de %{manufacturer} %{model}",
            "modules": "Editar módulos de %{manufacturer} %{model}",
            "paints": "Editar pinturas de %{manufacturer} %{model}",
            "images": "Editar imágenes de %{manufacturer} %{model}",
            "videos": "Editar videos de %{manufacturer} %{model}",
            "loaners": "Editar préstamos de %{manufacturer} %{model}",
            "snubCrafts": "Editar Snub Crafts de %{manufacturer} %{model}",
            "upgrades": "Editar mejoras de %{manufacturer} %{model}",
            "packages": "Editar paquetes de %{manufacturer} %{model}",
            "history": "Editar historial de %{manufacturer} %{model}"
          }
        },
        "components": {
          "index": "Componentes",
          "new": "Nuevo Componente",
          "edit": {
            "index": "Editar Componente",
            "prices": "Editar Precios del Componente",
            "history": "Editar Historial del Componente"
          }
        },
        "manufacturers": {
          "index": "Fabricantes",
          "new": "Nuevo Fabricante",
          "edit": {
            "index": "Editar Fabricante"
          }
        },
        "supporterContributions": {
          "index": "Contribuciones de patrocinadores",
          "new": "Nueva contribución de patrocinador",
          "edit": "Editar contribución de patrocinador"
        },
        "fundingGoals": {
          "index": "Objetivos de financiación",
          "new": "Nuevo objetivo de financiación",
          "edit": "Editar objetivo de financiación"
        },
        "users": {
          "index": "Usuarios",
          "edit": "Editar Usuario",
          "inventories": "Inventarios del usuario",
          "inventory": "Inventario del usuario",
          "inventoryItem": "Entrada de inventario",
          "fleets": "Flotas del usuario"
        },
        "vehicles": {
          "index": "Vehículos",
          "edit": "Editar Vehículo"
        },
        "admins": {
          "index": "Administradores",
          "new": "Nuevo Admin",
          "edit": "Editar Admin"
        },
        "fleets": {
          "index": "Flotas",
          "edit": "Editar Flota",
          "members": "Miembros de la flota",
          "memberEdit": "Editar miembro de la flota",
          "history": "Historial de la flota",
          "roles": "Roles de la flota",
          "role": "Rol de la flota",
          "inventories": "Inventarios de la flota",
          "inventory": "Inventario de la flota",
          "inventoryItem": "Entrada de inventario"
        },
        "oauthApplications": {
          "index": "Aplicaciones OAuth",
          "new": "Nueva aplicación OAuth",
          "edit": "Editar aplicación OAuth"
        },
        "features": {
          "index": "Indicadores de características",
          "show": "Detalles de la función"
        },
        "images": {
          "index": "Imágenes"
        },
        "notifications": {
          "index": "Notificaciones"
        },
        "maintenance": {
          "index": "Mantenimiento",
          "pghero": "PgHero",
          "features": "Funciones",
          "flipper": "Flipper UI",
          "workers": "Trabajadores",
          "tasks": "Tareas",
          "imports": "Importaciones",
          "importDetail": "Detalle de la importación",
          "rsiApiStatus": "Estado de API RSI"
        },
        "modelPaints": {
          "index": "Pinturas de Modelos",
          "edit": "Editar Pintura de Modelo"
        },
        "modelModules": {
          "index": "Módulos de Modelos",
          "edit": {
            "index": "Editar %{name} Datos Base",
            "models": "Editar %{name} Modelos",
            "prices": "Editar %{name} Precios",
            "hardpoints": "Editar puntos de montaje de %{name}",
            "cargoHolds": "Editar bodegas de carga de %{name}",
            "history": "Editar historial del módulo"
          }
        },
        "unlistedModels": {
          "index": "Naves no listadas"
        },
        "modelModulePackages": {
          "index": "Paquetes de Módulos de Modelos"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "Pruebas Visuales",
          "notifications": "Notificaciones - Pruebas Visuales"
        }
      },
      "notifications": "Notificaciones"
    }
  }
}
